/* Password rules for registration. */
export const PASSWORD_RULES = [
  { id: "length", label: "At least 8 characters", test: (v) => String(v || "").length >= 8 },
  { id: "uppercase", label: "One uppercase letter", test: (v) => /[A-Z]/.test(String(v || "")) },
  { id: "lowercase", label: "One lowercase letter", test: (v) => /[a-z]/.test(String(v || "")) },
  { id: "number", label: "One number", test: (v) => /[0-9]/.test(String(v || "")) },
  { id: "special", label: "One special character", test: (v) => /[!@#$%^&*]/.test(String(v || "")) },
];

export const passwordScore = (value) => PASSWORD_RULES.filter((r) => r.test(value)).length;

export const isPasswordValid = (value) => passwordScore(value) === PASSWORD_RULES.length;
